import Page from '@/components/Page/Page';
import AddContractLinesContainer from './AddContractLines.container';

export default function AddContractLines(): JSX.Element {
  return (
    <Page
      padding={true}
      pageTitle="Add Contract Line"
    >
      <AddContractLinesContainer />
    </Page>
  );
}
